import * as React from "react";

function SvgInvoice({ title, titleId, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h24v24H0z" />
        <path
          fill="currentColor"
          d="M17.5 2.25a2.75 2.75 0 012.745 2.582L20.25 5v14a2.75 2.75 0 01-2.582 2.745l-.168.005h-11a2.75 2.75 0 01-2.745-2.582L3.75 19V5a2.75 2.75 0 012.582-2.745L6.5 2.25h11zm0 1.5h-11a1.25 1.25 0 00-1.244 1.122L5.25 5v14c0 .648.491 1.18 1.122 1.244l.128.006h11a1.25 1.25 0 001.244-1.122L18.75 19V5a1.25 1.25 0 00-1.122-1.244L17.5 3.75zM16 17.25a.75.75 0 01.102 1.493L16 18.75H8a.75.75 0 01-.102-1.493L8 17.25h8zm0-3a.75.75 0 01.102 1.493L16 15.75H8a.75.75 0 01-.102-1.493L8 14.25h8zm-6.5-9a.75.75 0 01.743.648l.008.141c.495.105.92.415 1.189.856a.75.75 0 01-1.221.866l-.059-.084a.353.353 0 00-.219-.17L9.875 7.5h-.822a.303.303 0 00-.137.573l.063.024 1.407.353a1.803 1.803 0 01-.136 3.527V12a.75.75 0 01-1.493.102L8.75 12v-.037a1.846 1.846 0 01-1.192-.858.75.75 0 011.221-.865l.06.083a.349.349 0 00.22.172l.066.007h.822a.303.303 0 00.137-.573l-.063-.024-1.407-.353a1.803 1.803 0 01.136-3.527V6a.75.75 0 01.75-.75zm6.5 4.5a.75.75 0 01.102 1.493L16 11.25h-2a.75.75 0 01-.102-1.493L14 9.75h2zm0-3a.75.75 0 01.102 1.493L16 8.25h-2a.75.75 0 01-.102-1.493L14 6.75h2z"
        />
      </g>
    </svg>
  );
}

export default SvgInvoice;
